import React, { useState, useRef, useEffect } from "react";
import InvoiceGenerator from "../components/InvoiceGenerator";
import CategoryManager from "../components/CategoryManager"; // ✅ NEW
import { OrderFilterPanel, PaymentAttemptsSection } from "../components/OrderFilters";       // ✅ order filters + failed payments
import { EMPTY_FILTERS, applyOrderFilters, orderMethod, isFiltered } from "../utils/orderFilterUtils";
import { downloadOrdersExcel } from "../utils/ordersExcel";                                 // ✅ orders → Excel
const API  = process.env.REACT_APP_API_URL || "http://localhost:8000";
const PAGE_SIZE = 12; // ✅ products per page in the admin grid

// ✅ REMOVED: the hard-coded PRODUCT_CATEGORIES list. Categories now come
// from the database (Categories tab) so new ones can be added without
// touching the source code.

const STATUS_CFG = {
  Pending:   { bg:"#2a1f00", color:"#f5c842", dot:"#f5c842" },
  Confirmed: { bg:"#001a2e", color:"#4da6ff", dot:"#4da6ff" },
  Shipped:   { bg:"#1a0030", color:"#c084fc", dot:"#c084fc" },
  Delivered: { bg:"#002210", color:"#4ade80", dot:"#4ade80" },
  Cancelled: { bg:"#2a0000", color:"#f87171", dot:"#f87171" },
};

const getImgUrl = (img) => {
  if (!img) return null;
  if (img.startsWith("http")) return img;
  if (img.startsWith("uploads/")) return `${API}/${img}`;
  return `${API}/uploads/${img}`;
};

const getItemImg = (item) => {
  const raw = item.image || item.images?.[0] || "";
  return raw ? getImgUrl(raw) : null;
};

const renderAddress = (addr, fallbackName) => {
  if (!addr || Object.keys(addr).length === 0) return null;
  const newFormat = addr.fullName || addr.houseNo || addr.village;
  const oldFormat = addr.name || addr.street || addr.city;
  if (!newFormat && !oldFormat) return null;
  if (newFormat) {
    return {
      name:  addr.fullName || fallbackName || "—",
      phone: addr.phone || "",
      line1: [addr.houseNo, addr.landmark].filter(Boolean).join(", "),
      line2: [addr.village, addr.district].filter(Boolean).join(", "),
      line3: [addr.state, addr.pincode ? `— ${addr.pincode}` : ""].filter(Boolean).join(" "),
    };
  }
  return {
    name:  addr.name || fallbackName || "—",
    phone: addr.phone || "",
    line1: addr.street || addr.address || "",
    line2: [addr.city, addr.state].filter(Boolean).join(", "),
    line3: addr.pincode ? `PIN: ${addr.pincode}` : "",
  };
};

// ── WhatsApp order sender ──────────────────────────────
const sendOrderToWhatsApp = (order) => {
  const items     = order.products || order.items || [];
  const total     = Number(order.total_amount || order.totalAmount || 0);
  const shortId   = String(order._id).slice(-8).toUpperCase();
  const payMethod = order.payment_method || order.paymentMethod || "COD";
  const addr      = order.address || {};
  const date      = new Date(order.createdAt || Date.now())
    .toLocaleDateString("en-IN", { day:"2-digit", month:"short", year:"numeric" });
  const toName    = addr.fullName || addr.name || order.userName || order.email?.split("@")[0] || "Customer";
  const toPhone   = addr.phone || "";
  const toAddress = [addr.houseNo||addr.street||addr.address,addr.landmark,addr.village||addr.city,addr.district,addr.state,addr.pincode?`Pin Code: ${addr.pincode}`:""].filter(Boolean).join(",\n");
  const FROM_NAME  = "Reshma";
  const FROM_PHONE = "919390905464";
  const FROM_ADDRESS = "H No: 5-94/260, Srujanalaxmi Nagar,\nRoad number-7, Phase-2, Patelguda,\nPatancheru, Hyderabad,\nTelangana, Pin Code: 502319\nContact number: "+FROM_PHONE;
  const lines = [
    `🥻 *MANA VASTRALU*`,`_Mana Vastralu - Mana Garthimpu_`,`📷 @mana_vastralu  |  📞 ${FROM_PHONE}`,``,
    `━━━━━━━━━━━━━━━━━━━━━━━━━`,`📦 Order ID: #${shortId}`,`📅 Date: ${date}`,`💳 Payment: ${payMethod}`,``,
    `━━━━━━━━━━━━━━━━━━━━━━━━━`,`📬 TO,`,`${toName},`,`${toAddress}`,toPhone?`📞: ${toPhone}.`:"",``,
    `━━━━━━━━━━━━━━━━━━━━━━━━━`,`🏠 FROM,`,`Name : ${FROM_NAME}`,`${FROM_ADDRESS}`,``,
    `━━━━━━━━━━━━━━━━━━━━━━━━━`,`🛍️ *Items Ordered:*`,
    ...items.map((item,i)=>{
      const size=item.selectedSize||item.size||"";
      const meta=[size?`Size: ${size}`:"",item.color||""].filter(Boolean).join(" · ");
      const lineTotal=(Number(item.price||0)*(item.quantity||1)).toLocaleString("en-IN");
      return `${i+1}. *${item.name}*`+(meta?`\n   ${meta}`:"")+`\n   Qty: ${item.quantity||1} × ₹${Number(item.price||0).toLocaleString("en-IN")} = ₹${lineTotal}`;
    }),
    ``,`━━━━━━━━━━━━━━━━━━━━━━━━━`,`💰 *Total: ₹${total.toLocaleString("en-IN")}*`,``,
    `━━━━━━━━━━━━━━━━━━━━━━━━━`,`🙏 *THANK YOU for your purchase!*`,`_Thanks for your support_ 💛`,`━━━━━━━━━━━━━━━━━━━━━━━━━`,
  ].filter(l=>l!==undefined);
  window.open(`https://wa.me/919390905464?text=${encodeURIComponent(lines.join("\n"))}`, "_blank");
};

// ── Barcode Scanner ────────────────────────────────────
function BarcodeScanner({ onScan, onClose }) {
  const videoRef=useRef(null); const readerRef=useRef(null); const streamRef=useRef(null);
  const [error,setError]=useState(""); const [scanning,setScanning]=useState(true);
  const [scanned,setScanned]=useState(""); const [cameras,setCameras]=useState([]); const [camIdx,setCamIdx]=useState(0);
  const stopScanner=()=>{ try{readerRef.current?.reset();}catch{} if(streamRef.current){streamRef.current.getTracks().forEach(t=>t.stop());streamRef.current=null;} };
  const startScanner=async(idx)=>{
    setError("");setScanning(true);setScanned("");stopScanner();
    try{
      const {BrowserMultiFormatReader,BarcodeFormat,DecodeHintType}=await import("@zxing/library");
      const hints=new Map(); hints.set(DecodeHintType.POSSIBLE_FORMATS,[BarcodeFormat.CODE_128,BarcodeFormat.CODE_39,BarcodeFormat.QR_CODE,BarcodeFormat.EAN_13,BarcodeFormat.EAN_8,BarcodeFormat.UPC_A]);
      const reader=new BrowserMultiFormatReader(hints); readerRef.current=reader;
      const devices=await navigator.mediaDevices.enumerateDevices();
      const videoDevices=devices.filter(d=>d.kind==="videoinput"); setCameras(videoDevices);
      const deviceId=videoDevices[idx]?.deviceId||undefined;
      await reader.decodeFromVideoDevice(deviceId,videoRef.current,(result)=>{if(result){const code=result.getText();setScanned(code);setScanning(false);stopScanner();onScan(code);}});
      if(videoRef.current?.srcObject) streamRef.current=videoRef.current.srcObject;
    }catch(err){
      if(err.name==="NotAllowedError") setError("Camera permission denied.");
      else if(err.message?.includes("Cannot find module")) setError("Run: npm install @zxing/library");
      else setError("Camera error: "+err.message);
      setScanning(false);
    }
  };
  useEffect(()=>{startScanner(camIdx);return()=>stopScanner();},[camIdx]); // eslint-disable-line
  return(
    <div style={{position:"fixed",inset:0,zIndex:9999,background:"rgba(0,0,0,0.93)",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:"#1a1008",border:"1px solid rgba(200,160,74,0.3)",borderRadius:16,padding:24,width:"100%",maxWidth:400,display:"flex",flexDirection:"column",alignItems:"center",gap:16}}>
        <p style={{fontFamily:"'DM Sans',sans-serif",fontSize:15,fontWeight:700,color:"#c8a04a",margin:0}}>📷 Scan Tracking Barcode</p>
        {error?(<div style={{background:"rgba(198,40,40,0.1)",border:"1px solid rgba(198,40,40,0.3)",borderRadius:8,padding:"12px 16px",color:"#f87171",fontSize:12,textAlign:"center",width:"100%"}}>⚠️ {error}</div>)
        :scanned?(<div style={{background:"rgba(74,222,128,0.1)",border:"1px solid rgba(74,222,128,0.3)",borderRadius:8,padding:"12px 16px",color:"#4ade80",fontSize:13,fontWeight:700,textAlign:"center",width:"100%",wordBreak:"break-all"}}>✅ Scanned:<br/><span style={{fontSize:15}}>{scanned}</span></div>)
        :(<div style={{position:"relative",width:"100%",borderRadius:10,overflow:"hidden",background:"#000",aspectRatio:"4/3"}}><video ref={videoRef} autoPlay muted playsInline style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/></div>)}
        <div style={{display:"flex",gap:8,width:"100%"}}>
          {scanned?(<><button onClick={()=>{onScan(scanned);stopScanner();onClose();}} style={{flex:1,padding:"10px",background:"#c8a04a",color:"#1a1008",border:"none",borderRadius:8,fontSize:12,fontWeight:700,cursor:"pointer"}}>✅ Use This Code</button><button onClick={()=>startScanner(camIdx)} style={{flex:1,padding:"10px",background:"transparent",color:"#9a7050",border:"1px solid rgba(200,160,74,0.2)",borderRadius:8,fontSize:12,cursor:"pointer"}}>🔄 Scan Again</button></>)
          :error?(<><button onClick={()=>startScanner(camIdx)} style={{flex:1,padding:"10px",background:"#c8a04a",color:"#1a1008",border:"none",borderRadius:8,fontSize:12,fontWeight:700,cursor:"pointer"}}>🔄 Try Again</button><button onClick={()=>{stopScanner();onClose();}} style={{flex:1,padding:"10px",background:"rgba(198,40,40,0.15)",color:"#f87171",border:"1px solid rgba(198,40,40,0.3)",borderRadius:8,fontSize:12,cursor:"pointer"}}>✕ Close</button></>)
          :(<><button onClick={()=>{stopScanner();onClose();}} style={{flex:1,padding:"10px",background:"rgba(198,40,40,0.15)",color:"#f87171",border:"1px solid rgba(198,40,40,0.3)",borderRadius:8,fontSize:12,cursor:"pointer"}}>✕ Cancel</button></>)}
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════
//  SIZE-STOCK EDITOR COMPONENT
//  Shows per-size stock input for products with sizes
// ══════════════════════════════════════════════════════
function SizeStockEditor({ sizes, sizeStock, onChange }) {
  // sizeStock = { S: 5, M: 4, L: 0, XL: 2 }
  const total = Object.values(sizeStock).reduce((sum, v) => sum + Number(v || 0), 0);

  return (
    <div style={{ marginBottom:12 }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
        <label style={S.formLabel}>Stock per Size</label>
        <span style={{ fontSize:11, color:"#c8a04a", fontFamily:"'DM Sans',sans-serif", fontWeight:600 }}>
          Total: {total} pcs
        </span>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(90px,1fr))", gap:8 }}>
        {sizes.map(size => {
          const qty  = Number(sizeStock[size] || 0);
          const isSoldOut = qty === 0;
          return (
            <div key={size} style={{
              background: isSoldOut ? "rgba(198,40,40,0.08)" : "rgba(200,160,74,0.05)",
              border: `1px solid ${isSoldOut ? "rgba(198,40,40,0.3)" : "rgba(200,160,74,0.2)"}`,
              borderRadius:8, padding:"8px 10px", textAlign:"center",
            }}>
              <div style={{
                fontSize:12, fontWeight:700,
                color: isSoldOut ? "#f87171" : "#c8a04a",
                fontFamily:"'DM Sans',sans-serif",
                marginBottom:6,
              }}>
                {size}
                {isSoldOut && <span style={{ fontSize:9, display:"block", color:"#f87171" }}>SOLD OUT</span>}
              </div>
              <input
                type="number"
                min="0"
                value={sizeStock[size] ?? ""}
                onChange={e => onChange(size, e.target.value)}
                style={{
                  width:"100%", padding:"5px 6px", fontSize:13, fontWeight:700,
                  textAlign:"center",
                  background:"#0f0a04",
                  border:`1px solid ${isSoldOut ? "rgba(198,40,40,0.4)" : "rgba(200,160,74,0.25)"}`,
                  borderRadius:5, color: isSoldOut ? "#f87171" : "#e8d5a3",
                  outline:"none", fontFamily:"monospace",
                }}
              />
              <div style={{ fontSize:9, color:"#5a3a10", marginTop:3, fontFamily:"'DM Sans',sans-serif" }}>
                pcs
              </div>
            </div>
          );
        })}
      </div>

      {/* Visual stock bar */}
      <div style={{ marginTop:10 }}>
        <div style={{ display:"flex", gap:2, height:6, borderRadius:4, overflow:"hidden" }}>
          {sizes.map(size => {
            const qty = Number(sizeStock[size] || 0);
            return (
              <div key={size} style={{
                flex: total > 0 ? qty / total : 1,
                background: qty === 0 ? "rgba(198,40,40,0.3)" : "#c8a04a",
                transition:"flex .3s",
                minWidth: qty > 0 ? 4 : 2,
              }} title={`${size}: ${qty} pcs`}/>
            );
          })}
        </div>
        <div style={{ display:"flex", gap:8, marginTop:6, flexWrap:"wrap" }}>
          {sizes.map(size => {
            const qty = Number(sizeStock[size] || 0);
            return (
              <span key={size} style={{
                fontSize:10, fontFamily:"'DM Sans',sans-serif",
                color: qty === 0 ? "#f87171" : "#9a7050",
              }}>
                {size}: {qty}
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════
//  2FA LOGIN
// ══════════════════════════════════════════════════════
function AdminLogin2FA({ onSuccess }) {
  const [step,setStep]=useState(1); const [password,setPassword]=useState("");
  const [otp,setOtp]=useState(["","","","","",""]); const [loading,setLoading]=useState(false);
  const [error,setError]=useState(""); const [info,setInfo]=useState(""); const [timeLeft,setTimeLeft]=useState(0);
  const otpRefs=useRef([]);
  useEffect(()=>{if(step!==2||timeLeft<=0)return;const t=setInterval(()=>setTimeLeft(s=>s<=1?(clearInterval(t),0):s-1),1000);return()=>clearInterval(t);},[step,timeLeft]);
  const fmt=(s)=>`${Math.floor(s/60)}:${String(s%60).padStart(2,"0")}`;
  const handlePasswordSubmit=async()=>{
    if(!password){setError("Enter your admin password");return;} setLoading(true);setError("");setInfo("");
    try{const res=await fetch(`${API}/api/admin/request-otp`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({password})});const data=await res.json();
    if(!res.ok||!data.success){setError(data.message||"Incorrect password");}else{setInfo(data.message);setStep(2);setTimeLeft(300);setTimeout(()=>otpRefs.current[0]?.focus(),100);}}catch{setError("Cannot connect to server.");}setLoading(false);
  };
  const handleOtpChange=(i,val)=>{const v=val.replace(/\D/g,"").slice(-1);const next=[...otp];next[i]=v;setOtp(next);setError("");if(v&&i<5)otpRefs.current[i+1]?.focus();if(v&&i===5&&next.every(d=>d!==""))handleOtpSubmit(next.join(""));};
  const handleOtpKeyDown=(i,e)=>{if(e.key==="Backspace"&&!otp[i]&&i>0)otpRefs.current[i-1]?.focus();if(e.key==="Enter"&&otp.every(d=>d!==""))handleOtpSubmit(otp.join(""));};
  const handleOtpPaste=(e)=>{e.preventDefault();const pasted=e.clipboardData.getData("text").replace(/\D/g,"").slice(0,6);if(pasted.length===6){setOtp(pasted.split(""));handleOtpSubmit(pasted);}};
  const handleOtpSubmit=async(otpVal)=>{
    const code=otpVal||otp.join("");if(code.length!==6){setError("Enter the 6-digit OTP");return;}if(timeLeft===0){setError("OTP expired.");return;}setLoading(true);setError("");
    try{const res=await fetch(`${API}/api/admin/verify-otp`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({otp:code})});const data=await res.json();
    if(!res.ok||!data.success){setError(data.message||"Invalid OTP");setOtp(["","","","","",""]);otpRefs.current[0]?.focus();}else{onSuccess(data.sessionToken, password);}}catch{setError("Cannot connect to server.");}setLoading(false);
  };
  const resendOtp=async()=>{if(timeLeft>240)return;setOtp(["","","","","",""]);setLoading(true);setError("");setInfo("");
    try{const res=await fetch(`${API}/api/admin/request-otp`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({password})});const data=await res.json();
    if(data.success){setInfo("New OTP sent!");setTimeLeft(300);setTimeout(()=>otpRefs.current[0]?.focus(),100);}else setError(data.message);}catch{setError("Failed to resend");}setLoading(false);
  };
  return(
    <div style={S.loginPage}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=DM+Sans:wght@300;400;500&display=swap');@keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}.l-box{animation:fadeUp .5s ease both}.l-inp:focus{border-color:#c8a04a!important}.l-btn:hover{background:#d4aa55!important;transform:translateY(-1px)}.l-back:hover{border-color:rgba(200,160,74,0.3)!important;color:#c8a04a!important}.otp-i:focus{border-color:#c8a04a!important}`}</style>
      <div className="l-box" style={S.loginBox}>
        <div style={{width:56,height:56,background:"linear-gradient(135deg,#c8a04a,#8b5e1a)",borderRadius:12,display:"flex",alignItems:"center",justifyContent:"center",fontSize:26,margin:"0 auto 16px"}}>🥻</div>
        <h1 style={{fontFamily:"'Playfair Display',serif",fontSize:24,color:"#e8d5a3",margin:"0 0 4px",textAlign:"center"}}>Mana Vastralu</h1>
        <p style={{fontFamily:"'DM Sans',sans-serif",fontSize:11,color:"#7a5a30",textAlign:"center",margin:"0 0 20px",letterSpacing:"0.1em",textTransform:"uppercase"}}>{step===1?"Admin Console":"Two-Factor Auth"}</p>
        <div style={{display:"flex",justifyContent:"center",gap:8,marginBottom:20}}>{[1,2].map(s=>(<div key={s} style={{height:6,borderRadius:3,transition:"all .3s",width:step===s?24:8,background:step>=s?"#c8a04a":"rgba(200,160,74,0.2)"}}/>))}</div>
        {error&&<div style={{fontSize:12,color:"#f87171",margin:"0 0 12px",background:"rgba(198,40,40,0.1)",padding:"8px 12px",borderRadius:6,border:"1px solid rgba(198,40,40,0.2)"}}>⚠️ {error}</div>}
        {info&&<div style={{fontSize:12,color:"#4ade80",margin:"0 0 12px",background:"rgba(74,222,128,0.08)",padding:"8px 12px",borderRadius:6,border:"1px solid rgba(74,222,128,0.2)"}}>✓ {info}</div>}
        {step===1&&(<>
          <label style={{display:"block",fontSize:10,fontWeight:600,color:"#7a5a30",textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:6}}>Admin Password</label>
          <input className="l-inp" type="password" placeholder="Enter admin password" value={password} onChange={e=>{setPassword(e.target.value);setError("");}} onKeyDown={e=>e.key==="Enter"&&handlePasswordSubmit()} style={{width:"100%",padding:"12px 14px",fontSize:14,border:"1.5px solid rgba(200,160,74,0.25)",borderRadius:8,outline:"none",background:"#0f0a04",color:"#e8d5a3",marginBottom:12,boxSizing:"border-box"}}/>
          <button className={loading?"":"l-btn"} onClick={handlePasswordSubmit} disabled={loading} style={{width:"100%",padding:"13px",background:loading?"#5a3a10":"#c8a04a",color:loading?"#9a7050":"#1a1008",border:"none",borderRadius:8,fontSize:14,fontWeight:700,cursor:loading?"not-allowed":"pointer",letterSpacing:"0.06em",transition:"all .2s"}}>{loading?"Sending OTP…":"Continue →"}</button>
        </>)}
        {step===2&&(<>
          <p style={{fontSize:13,color:"#9a7050",textAlign:"center",margin:"0 0 20px",lineHeight:1.6}}>Enter the 6-digit OTP sent to<br/><strong style={{color:"#c8a04a"}}>your admin email</strong></p>
          <div style={{display:"flex",gap:8,marginBottom:14,justifyContent:"center"}} onPaste={handleOtpPaste}>
            {otp.map((digit,i)=>(<input key={i} ref={el=>otpRefs.current[i]=el} className="otp-i" type="text" inputMode="numeric" maxLength={1} value={digit} onChange={e=>handleOtpChange(i,e.target.value)} onKeyDown={e=>handleOtpKeyDown(i,e)} style={{width:44,height:52,textAlign:"center",fontSize:22,fontWeight:700,border:`1.5px solid ${digit?"#c8a04a":"rgba(200,160,74,0.25)"}`,borderRadius:8,background:digit?"rgba(200,160,74,0.08)":"#0f0a04",color:"#c8a04a",outline:"none",fontFamily:"monospace"}}/>))}
          </div>
          <div style={{textAlign:"center",fontSize:12,color:"#7a5a30",marginBottom:14}}>{timeLeft>0?`⏱ OTP expires in ${fmt(timeLeft)}`:<span style={{color:"#f87171"}}>OTP expired</span>}</div>
          <button className={loading||otp.some(d=>!d)?"":"l-btn"} onClick={()=>handleOtpSubmit()} disabled={loading||otp.some(d=>!d)} style={{width:"100%",padding:"13px",background:loading||otp.some(d=>!d)?"#5a3a10":"#c8a04a",color:loading||otp.some(d=>!d)?"#9a7050":"#1a1008",border:"none",borderRadius:8,fontSize:14,fontWeight:700,cursor:loading||otp.some(d=>!d)?"not-allowed":"pointer",transition:"all .2s",marginBottom:8}}>{loading?"Verifying…":"Verify & Sign In →"}</button>
          <button className="l-back" onClick={resendOtp} disabled={loading||timeLeft>240} style={{width:"100%",padding:"10px",background:"transparent",border:"1px solid rgba(200,160,74,0.15)",borderRadius:8,color:"#7a5a30",fontSize:12,cursor:loading||timeLeft>240?"not-allowed":"pointer",marginBottom:8,opacity:timeLeft>240?0.4:1,transition:"all .2s"}}>{timeLeft>240?`Resend in ${fmt(timeLeft-240)}`:"↩ Resend OTP"}</button>
          <button className="l-back" onClick={()=>{setStep(1);setOtp(["","","","","",""]);setError("");setInfo("");}} style={{width:"100%",padding:"10px",background:"transparent",border:"1px solid rgba(200,160,74,0.15)",borderRadius:8,color:"#7a5a30",fontSize:12,cursor:"pointer",transition:"all .2s"}}>← Back to Password</button>
        </>)}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════
//  MAIN DASHBOARD
// ══════════════════════════════════════════════════════
export default function AdminDashboard() {
  const [authed,setAuthed]=useState(false);
  const [pass,setPass]=useState("");
  const [tab,setTab]=useState("products");
  const [filter,setFilter]=useState("All");
  const [orderDraft,setOrderDraft]=useState(EMPTY_FILTERS);      // filter panel (being edited)
  const [orderApplied,setOrderApplied]=useState(EMPTY_FILTERS);  // filters in effect (after "Apply")
  const [showOrderFilters,setShowOrderFilters]=useState(false);
  const [attemptMethods,setAttemptMethods]=useState([]);         // payment methods seen in failed/pending checkouts
  const [users,setUsers]=useState([]);
  const [products,setProducts]=useState([]);
  const [orders,setOrders]=useState([]);
  const [unreadCount,setUnreadCount]=useState(0);          // 🔴 badge on Orders (from the database)
  const [newOrderIds,setNewOrderIds]=useState([]);          // orders that were unseen when Orders was opened
  const [categories,setCategories]=useState([]); // ✅ NEW — from the database, includes productCount
  const [editingProduct,setEditingProduct]=useState(null);
  const [editForm,setEditForm]=useState({});
  const [editSizeStock,setEditSizeStock]=useState({}); // { S:5, M:4, L:0 }
  const [showAddForm,setShowAddForm]=useState(false);
  const [addForm,setAddForm]=useState({name:"",description:"",price:"",originalPrice:"",fabric:"",color:"",categoryId:"",stock:"10",sizes:""});
  const [addSizeStock,setAddSizeStock]=useState({}); // size-wise stock for new product
  const [addImages,setAddImages]=useState([]);
  const [addLoading,setAddLoading]=useState(false);
  const [addSuccess,setAddSuccess]=useState("");
  const [trackingForm,setTrackingForm]=useState({});
  const [trackingOpen,setTrackingOpen]=useState(null);
  const [scannerOpen,setScannerOpen]=useState(null);

  const [stockAlerts,setStockAlerts]=useState([]);
  const [alertsOpen,setAlertsOpen]=useState(false);
  const [payAlerts,setPayAlerts]=useState([]);            // ✅ NEW — payment problems from the server
  const [payAlertsOpen,setPayAlertsOpen]=useState(false);

  const [productSearch,setProductSearch]=useState("");
  const [categoryFilter,setCategoryFilter]=useState("All"); // "All" or a category _id
  const [stockFilter,setStockFilter]=useState("All"); // All | In Stock | Low Stock | Sold Out
  const [currentPage,setCurrentPage]=useState(1);

  const [categoryPreviewOpen,setCategoryPreviewOpen]=useState(true);

  const fmtDate=(d)=>d?new Date(d).toLocaleDateString("en-IN",{day:"2-digit",month:"short",year:"numeric"}):"—";
  // same rule as the server (backend/services/stock.js): sold-out flag, then the stock of the
  // sizes actually offered (any capitalisation), otherwise `stock`; missing numbers count as 0
  const isSoldOut=(p)=>{
    if(p.soldOut) return true;
    const ss=p.sizeStock&&typeof p.sizeStock==="object"?p.sizeStock:{};
    const sizes=(p.sizes||[]).map(s=>String(s).trim()).filter(Boolean);
    const keys=Object.keys(ss);
    if(sizes.length&&keys.length){
      const total=sizes.reduce((t,s)=>{const k=keys.find(x=>x.trim().toLowerCase()===s.toLowerCase());const n=Number(k===undefined?0:ss[k]);return t+(Number.isFinite(n)&&n>0?n:0);},0);
      return total<=0;
    }
    const n=Number(p.stock);
    return !Number.isFinite(n)||n<=0;
  };
  const isLowStock=(p)=>!isSoldOut(p)&&Number(p.stock)<=3;

  // ✅ NEW — a product references ONE category by id
  const pCatId=(p)=>String(p.categoryId?._id||p.categoryId||"");
  const catName=(p)=>categories.find(c=>c._id===pCatId(p))?.name||p.category||"";

  // Parse sizeStock from product — stored in product.sizeStock or derived from sizes+stock
  const getSizeStock = (p) => {
    if (p.sizeStock && Object.keys(p.sizeStock).length > 0) return p.sizeStock;
    // Fallback: distribute stock equally across sizes
    if (p.sizes?.length > 0) {
      const each = Math.floor((Number(p.stock) || 0) / p.sizes.length);
      const result = {};
      p.sizes.forEach(s => { result[s] = each; });
      return result;
    }
    return {};
  };

  const handleAuthSuccess = async (token, enteredPass) => {
    try {
      const [uRes,pRes,oRes,aRes,cRes] = await Promise.all([
        fetch(`${API}/api/admin/users?password=${enteredPass}`),
        fetch(`${API}/api/admin/products?password=${enteredPass}`),
        fetch(`${API}/api/admin/orders?password=${enteredPass}`),
        fetch(`${API}/api/admin/stock-alerts?password=${enteredPass}`),
        fetch(`${API}/api/admin/categories?password=${encodeURIComponent(enteredPass)}`),
      ]);

      if (!uRes.ok || !pRes.ok || !oRes.ok) {
        let errMsg = "Failed to load admin data.";
        try {
          const errData = await pRes.json();
          if (errData.error) errMsg = errData.error;
        } catch {}
        alert("⚠️ Authentication failed: " + errMsg);
        return;
      }

      const uData = await uRes.json();
      const pData = await pRes.json();
      const oData = await oRes.json();

      if (!Array.isArray(pData)) {
        alert("⚠️ Invalid products data structure received from server.");
        return;
      }

      setPass(enteredPass);
      setUsers(Array.isArray(uData) ? uData : []);
      setProducts(pData);
      setOrders(Array.isArray(oData) ? oData : []);
      setStockAlerts(aRes.ok ? await aRes.json() : []);
      if (cRes.ok) { const cData = await cRes.json(); setCategories(Array.isArray(cData) ? cData : []); }
      setAuthed(true);
    } catch(err) {
      console.error("Load failed:", err);
      alert("⚠️ Network error: Could not load data from backend server.");
    }
  };

  // ✅ NEW — reload categories (names, status, LIVE product counts)
  const loadCategories = async () => {
    try {
      const res = await fetch(`${API}/api/admin/categories?password=${encodeURIComponent(pass)}`);
      if (res.ok) { const d = await res.json(); setCategories(Array.isArray(d) ? d : []); }
    } catch { /* non-critical */ }
  };

  // After the Categories tab changes something (rename etc.) the product
  // list also needs a refresh so names/badges stay correct.
  const reloadProducts = async () => {
    try {
      const res = await fetch(`${API}/api/admin/products?password=${pass}`);
      if (res.ok) { const d = await res.json(); if (Array.isArray(d)) setProducts(d); }
    } catch { /* non-critical */ }
  };

  const onCategoriesChanged = () => { loadCategories(); reloadProducts(); };

  const refreshStockAlerts = async () => {
    try {
      const res = await fetch(`${API}/api/admin/stock-alerts?password=${pass}`);
      if (res.ok) setStockAlerts(await res.json());
    } catch { /* non-critical — banner just stays stale until next refresh */ }
    loadCategories(); // product counts change whenever products are added/removed
  };

  const handleAddTracking = async (orderId) => {
    const form=trackingForm[orderId]||{};
    if(!form.trackingNumber){alert("Enter tracking number");return;}
    try{
      const res=await fetch(`${API}/api/admin/orders/${orderId}/tracking`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({password:pass,courierName:form.courierName||"DTDC",trackingNumber:form.trackingNumber,estimatedDelivery:form.estimatedDelivery||"",status:"Shipped"})});
      const data=await res.json();
      setOrders(orders.map(o=>o._id===orderId?{...o,...data.order}:o));
      setTrackingOpen(null); alert("✅ Tracking added!");
    }catch{alert("Failed to add tracking");}
  };

  const handleImageSelect=(e)=>{
    const files=Array.from(e.target.files);
    setAddImages(prev=>{const combined=[...prev,...files];if(combined.length>4){alert("Maximum 4 images.");return combined.slice(0,4);}return combined;});
    e.target.value="";
  };

  const handleAddProduct = async () => {
    if(!addForm.name||!addForm.price){alert("Name and Price required");return;}
    if(!addForm.categoryId){alert("Please select a category");return;}
    if(addImages.length===0){alert("Upload at least 1 image");return;}
    setAddLoading(true);
    try{
      const fd=new FormData();
      const sizes=addForm.sizes.split(",").map(s=>s.trim()).filter(Boolean);
      const totalStock = sizes.length > 0
        ? Object.values(addSizeStock).reduce((s,v)=>s+Number(v||0),0)
        : Number(addForm.stock) || 10;

      Object.entries(addForm).forEach(([k,v])=>{
        if(k==="sizes") fd.append(k,JSON.stringify(sizes));
        else if(k==="stock") fd.append(k, String(totalStock));
        else fd.append(k,v);
      });

      if(sizes.length > 0) {
        fd.append("sizeStock", JSON.stringify(addSizeStock));
      }

      addImages.forEach(img=>fd.append("images",img));
      fd.append("password", pass);   // server requires the admin password to store images
      const res=await fetch(`${API}/api/products`,{method:"POST",body:fd});
      const data=await res.json();
      if(!res.ok){
        alert("Error: "+(data.error||"Upload failed"));
        setAddLoading(false);
        return;
      }
      setProducts([data,...products]);
      setAddForm({name:"",description:"",price:"",originalPrice:"",fabric:"",color:"",categoryId:"",stock:"10",sizes:""});
      setAddImages([]); setAddSizeStock({});
      setAddSuccess(`Product added with ${data.images?.length||0} image(s)!`);
      setTimeout(()=>setAddSuccess(""),3000);
      setShowAddForm(false);
      refreshStockAlerts();
    }catch(err){alert("Failed: "+err.message);}
    setAddLoading(false);
  };

  const handleEnableSizeTracking = async (p) => {
    const estimate = getSizeStock(p);
    const totalStock = Object.values(estimate).reduce((s,v)=>s+Number(v||0),0);
    const payload = {
      name: p.name, description: p.description||"", price: p.price,
      originalPrice: p.originalPrice||"", fabric: p.fabric||"", color: p.color||"",
      ...(pCatId(p) ? { categoryId: pCatId(p) } : {}),
      sizes: p.sizes||[],
      stock: totalStock, soldOut: totalStock === 0,
      sizeStock: estimate,
    };
    try{
      await fetch(`${API}/api/products/${p._id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(payload)});
      setProducts(products.map(pr=>pr._id===p._id?{...pr,...payload}:pr));
      refreshStockAlerts();
    }catch{alert("Failed to enable size tracking — please try again.");}
  };

  const handleUpdateProduct = async (id) => {
    try{
      const sizes = typeof editForm.sizes==="string"
        ? editForm.sizes.split(",").map(s=>s.trim()).filter(Boolean)
        : (editForm.sizes||[]);

      const totalStock = sizes.length > 0 && Object.keys(editSizeStock).length > 0
        ? Object.values(editSizeStock).reduce((s,v)=>s+Number(v||0),0)
        : Number(editForm.stock)||0;

      const payload={
        ...editForm,
        sizes,
        stock: totalStock,
        soldOut: totalStock === 0,
        sizeStock: sizes.length > 0 ? editSizeStock : {},
      };
      const res = await fetch(`${API}/api/products/${id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(payload)});
      if(!res.ok){ const d=await res.json().catch(()=>({})); alert("Update failed: "+(d.error||res.status)); return; }
      const newName = categories.find(c=>c._id===editForm.categoryId)?.name;
      setProducts(products.map(p=>p._id===id?{...p,...payload,...(newName?{category:newName}:{})}:p));
      setEditingProduct(null);
      refreshStockAlerts();
    }catch{alert("Update failed");}
  };

  const markSoldOut=async(p)=>{
    const sizes=typeof editForm.sizes==="string"?editForm.sizes.split(",").map(s=>s.trim()).filter(Boolean):(editForm.sizes||[]);
    const zeroSizeStock={};sizes.forEach(s=>{zeroSizeStock[s]=0;});
    const payload={...editForm,sizes,stock:0,soldOut:true,sizeStock:zeroSizeStock};
    await fetch(`${API}/api/products/${p._id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(payload)});
    setProducts(products.map(pr=>pr._id===p._id?{...pr,...payload}:pr));
    setEditingProduct(null);
    refreshStockAlerts();
  };

  const markInStock=async(p,newStock=10)=>{
    const sizes=typeof editForm.sizes==="string"?editForm.sizes.split(",").map(s=>s.trim()).filter(Boolean):(editForm.sizes||[]);
    const each=sizes.length>0?Math.floor(newStock/sizes.length):newStock;
    const newSizeStock={};sizes.forEach(s=>{newSizeStock[s]=each;});
    const payload={...editForm,sizes,stock:newStock,soldOut:false,sizeStock:newSizeStock};
    await fetch(`${API}/api/products/${p._id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(payload)});
    setProducts(products.map(pr=>pr._id===p._id?{...pr,...payload}:pr));
    setEditingProduct(null);
    refreshStockAlerts();
  };

  const handleDeleteProduct=async(id)=>{
    if(!window.confirm("Delete this product?"))return;
    await fetch(`${API}/api/products/${id}`,{method:"DELETE"});
    setProducts(products.filter(p=>p._id!==id));
    refreshStockAlerts();
  };

  // ── Unread-order notification ──────────────────────────────────────────────
  // Count comes from GET /api/admin/orders/unread-count (stored in MongoDB, so it
  // is the same on every device). Polled every 10 s while signed in.
  const fetchUnreadCount = async (p=pass) => {
    try {
      const r = await fetch(`${API}/api/admin/orders/unread-count?password=${encodeURIComponent(p)}`);
      if (r.ok) setUnreadCount((await r.json()).unreadCount || 0);
    } catch {}
  };
  // Opening Orders: load → show → mark exactly those orders viewed → refresh count
  const syncAndMarkOrders = async (p=pass) => {
    try {
      const r = await fetch(`${API}/api/admin/orders?password=${encodeURIComponent(p)}`);
      if (!r.ok) return;
      const list = await r.json();
      if (!Array.isArray(list)) return;
      const unseen = list.filter(o=>!o.adminViewedAt && o.status!=="Cancelled").map(o=>o._id);
      setOrders(list);
      if (unseen.length) {
        setNewOrderIds(prev=>Array.from(new Set([...prev,...unseen])));   // keeps the NEW tag while on this page
        await fetch(`${API}/api/admin/orders/mark-viewed`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({password:p,ids:unseen})});
      }
      await fetchUnreadCount(p);
    } catch {}
  };
  // ── Payment alerts (paid-but-no-order, double payments, uncaptured…) ──────
  const fetchPayAlerts = async (p=pass) => {
    try {
      const r = await fetch(`${API}/api/admin/payment-alerts?password=${encodeURIComponent(p)}`);
      if (r.ok) setPayAlerts((await r.json()).alerts || []);
    } catch {}
  };
  const resolvePayAlert = async (id) => {
    try {
      await fetch(`${API}/api/admin/payment-alerts/${id}/resolve`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({password:pass})});
      setPayAlerts(a=>a.filter(x=>x._id!==id));
    } catch { alert("Could not mark as resolved"); }
  };
  useEffect(()=>{
    if(!authed||!pass) return;
    fetchPayAlerts(pass);
    const t=setInterval(()=>fetchPayAlerts(pass),60000);
    return()=>clearInterval(t);
    // eslint-disable-next-line
  },[authed,pass]);

  const unreadRef = useRef(0); unreadRef.current = unreadCount;
  const tabRef    = useRef(tab); tabRef.current = tab;

  useEffect(()=>{            // on login + every 10 s
    if(!authed||!pass) return;
    fetchUnreadCount(pass);
    const t=setInterval(async()=>{
      await fetchUnreadCount(pass);
      // a new order arrived while the admin is already looking at Orders → show it, keep NEW tag
      if(tabRef.current==="orders") syncAndMarkOrders(pass);
    },10000);
    return()=>clearInterval(t);
    // eslint-disable-next-line
  },[authed,pass]);

  useEffect(()=>{            // admin enters / leaves the Orders page
    if(!authed||!pass) return;
    if(tab==="orders") syncAndMarkOrders(pass);
    else setNewOrderIds([]);                 // NEW tags vanish once the admin leaves the page
    // eslint-disable-next-line
  },[tab,authed]);

  const handleOrderStatus=async(id,status)=>{
    await fetch(`${API}/api/admin/orders/${id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({password:pass,status})});
    setOrders(orders.map(o=>o._id===id?{...o,status}:o));
  };

  if(!authed) return <AdminLogin2FA onSuccess={handleAuthSuccess}/>;

  const soldOutCount=products.filter(p=>isSoldOut(p)).length;
  const revenue=orders.reduce((s,o)=>s+Number(o.total_amount||o.totalAmount||0),0);
  const orderFilters={...orderApplied,status:filter};             // status pills and the panel share `filter`
  const visibleOrders=applyOrderFilters(orders,orderFilters);
  const ordersFiltered=isFiltered(orderApplied,filter);
  const orderMethods=[...new Set([...orders.map(orderMethod),...attemptMethods])].sort();
  const applyOrderFilterDraft=()=>{ setFilter(orderDraft.status); setOrderApplied(orderDraft); };
  const clearOrderFilters=()=>{ setOrderDraft(EMPTY_FILTERS); setOrderApplied(EMPTY_FILTERS); setFilter("All"); };
  const quickOrderRange=(k)=>{ const next={...orderApplied,range:k,from:"",to:""}; setOrderApplied(next); setOrderDraft(d=>({...d,range:k,from:"",to:""})); };
  const fmtDateTime=(d)=>d?new Date(d).toLocaleString("en-IN",{day:"2-digit",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit",hour12:true}):"—";

  const addFormSizes = addForm.sizes.split(",").map(s=>s.trim()).filter(Boolean);

  // ✅ NEW — dropdown options: active categories only (plus the one a product
  // already has, even if it was deactivated, so editing doesn't lose it)
  const activeCategories = categories.filter(c=>c.isActive);
  const optionsFor = (currentId) =>
    categories.filter(c=>c.isActive || c._id===currentId);

  const filteredProducts = products.filter(p=>{
    const q = productSearch.trim().toLowerCase();
    const matchesSearch = !q || `${p.name} ${catName(p)} ${p.fabric||""} ${p.color||""}`.toLowerCase().includes(q);
    const matchesCategory = categoryFilter==="All" || pCatId(p)===categoryFilter;
    let matchesStock = true;
    if (stockFilter==="In Stock")  matchesStock = !isSoldOut(p) && !isLowStock(p);
    if (stockFilter==="Low Stock") matchesStock = isLowStock(p);
    if (stockFilter==="Sold Out")  matchesStock = isSoldOut(p);
    return matchesSearch && matchesCategory && matchesStock;
  });

  const totalPages = Math.max(1, Math.ceil(filteredProducts.length / PAGE_SIZE));
  const safePage   = Math.min(currentPage, totalPages);
  const pagedProducts = filteredProducts.slice((safePage-1)*PAGE_SIZE, safePage*PAGE_SIZE);

  const updateSearch   = (v)=>{ setProductSearch(v);  setCurrentPage(1); };
  const updateCategory = (v)=>{ setCategoryFilter(v); setCurrentPage(1); };
  const updateStock    = (v)=>{ setStockFilter(v);    setCurrentPage(1); };

  return(
    <div style={S.page}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=DM+Sans:wght@300;400;500&display=swap');
        *{box-sizing:border-box}
        ::-webkit-scrollbar{width:6px;height:6px}::-webkit-scrollbar-track{background:#1e1409}::-webkit-scrollbar-thumb{background:#5c3a10;border-radius:3px}
        .tab-btn:hover{background:rgba(200,160,74,0.08)!important}
        .action-btn:hover{opacity:.85;transform:translateY(-1px)}
        .stat-card{transition:transform .2s}.stat-card:hover{transform:translateY(-3px)}
        select option{background:#2a1a08;color:#e8d5a3}
        .upload-zone:hover{border-color:rgba(200,160,74,0.7)!important;background:rgba(200,160,74,0.08)!important}
        .fpill{cursor:pointer;transition:all .15s}.fpill:hover{border-color:rgba(200,160,74,0.5)!important}
        .wa-btn:hover{opacity:.88;transform:translateY(-1px)}
        .scan-btn:hover{background:rgba(200,160,74,0.3)!important}
        .page-btn:hover:not(:disabled){border-color:rgba(200,160,74,0.5)!important;color:#c8a04a!important}
        .page-btn:disabled{opacity:.35;cursor:not-allowed}
        .alert-banner:hover{border-color:rgba(198,40,40,0.5)!important}
        .cat-card:hover{border-color:rgba(200,160,74,0.5)!important;transform:translateY(-2px)}
        input[type=number]::-webkit-inner-spin-button{opacity:0.4}
      `}</style>

      {/* SIDEBAR */}
      <aside style={S.sidebar}>
        <div style={{padding:"28px 20px 20px"}}>
          <div style={{width:44,height:44,background:"linear-gradient(135deg,#c8a04a,#8b5e1a)",borderRadius:10,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,marginBottom:12}}>🥻</div>
          <div style={{fontFamily:"'Playfair Display',serif",fontSize:16,color:"#e8d5a3",fontWeight:600,lineHeight:1.2}}>Mana Vastralu</div>
          <div style={{fontSize:10,color:"#7a5a30",marginTop:2,letterSpacing:"0.1em",textTransform:"uppercase"}}>Admin Console</div>
          <div style={{marginTop:8,display:"inline-flex",alignItems:"center",gap:5,background:"rgba(74,222,128,0.1)",border:"1px solid rgba(74,222,128,0.2)",borderRadius:20,padding:"3px 10px"}}>
            <span style={{width:6,height:6,borderRadius:"50%",background:"#4ade80",display:"inline-block"}}/>
            <span style={{fontSize:9,color:"#4ade80",fontFamily:"'DM Sans',sans-serif",letterSpacing:"0.5px"}}>2FA SECURED</span>
          </div>
        </div>
        <div style={{padding:"0 12px"}}>
          {[{key:"products",icon:"🛍️",label:"Products"},{key:"categories",icon:"🗂️",label:"Categories"},{key:"orders",icon:"📦",label:"Orders"},{key:"users",icon:"👥",label:"Users"}].map(t=>(
            <button key={t.key} className="tab-btn" onClick={()=>setTab(t.key)}
              style={{width:"100%",display:"flex",alignItems:"center",gap:10,padding:"11px 14px",marginBottom:4,background:tab===t.key?"rgba(200,160,74,0.15)":"transparent",border:tab===t.key?"1px solid rgba(200,160,74,0.25)":"1px solid transparent",borderRadius:8,cursor:"pointer",transition:"all .15s",color:tab===t.key?"#c8a04a":"#9a7050",fontSize:13,fontFamily:"'DM Sans',sans-serif",fontWeight:tab===t.key?500:400,textAlign:"left"}}>
              <span style={{fontSize:16}}>{t.icon}</span>{t.label}
              {t.key==="orders"&&unreadCount>0&&(
                <span style={{marginLeft:"auto",minWidth:20,height:20,padding:"0 6px",borderRadius:999,background:"#dc2626",color:"#fff",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,fontFamily:"'DM Sans',sans-serif",lineHeight:1}}>{unreadCount>99?"99+":unreadCount}</span>
              )}
              {tab===t.key&&<span style={{marginLeft:"auto",width:6,height:6,borderRadius:"50%",background:"#c8a04a"}}/>}
            </button>
          ))}
        </div>
        <div style={{marginTop:"auto",padding:"20px 12px"}}>
          <button onClick={()=>setAuthed(false)} style={{width:"100%",padding:"10px",background:"rgba(198,40,40,0.1)",border:"1px solid rgba(198,40,40,0.2)",borderRadius:8,color:"#f87171",fontSize:12,fontFamily:"'DM Sans',sans-serif",cursor:"pointer",letterSpacing:"0.06em"}}>Sign Out</button>
        </div>
      </aside>

      {/* MAIN */}
      <main style={S.main}>
        <div style={S.topbar}>
          <div>
            <h1 style={{fontFamily:"'Playfair Display',serif",fontSize:22,color:"#e8d5a3",margin:0,fontWeight:600}}>
              {tab==="products"?"Products":tab==="categories"?"Categories":tab==="orders"?"Orders":"Users"}
            </h1>
            <p style={{fontSize:12,color:"#7a5a30",margin:"2px 0 0",fontFamily:"'DM Sans',sans-serif"}}>
              {new Date().toLocaleDateString("en-IN",{weekday:"long",day:"numeric",month:"long",year:"numeric"})}
            </p>
          </div>
        </div>

        {payAlerts.length > 0 && (
          <div style={{background:"rgba(198,40,40,0.1)",border:"1px solid rgba(198,40,40,0.45)",borderRadius:12,padding:"14px 18px",marginBottom:20,cursor:"pointer"}}
            onClick={()=>setPayAlertsOpen(v=>!v)}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:12}}>
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                <span style={{fontSize:18}}>🚨</span>
                <span style={{fontSize:13,fontWeight:700,color:"#f87171",fontFamily:"'DM Sans',sans-serif"}}>
                  {payAlerts.length} payment issue{payAlerts.length!==1?"s":""} need{payAlerts.length===1?"s":""} attention
                </span>
              </div>
              <span style={{fontSize:11,color:"#7a5a30",fontFamily:"'DM Sans',sans-serif"}}>{payAlertsOpen?"Hide ▲":"View ▼"}</span>
            </div>
            {payAlertsOpen && (
              <div style={{marginTop:12,paddingTop:12,borderTop:"1px solid rgba(198,40,40,0.25)",display:"flex",flexDirection:"column",gap:10}} onClick={e=>e.stopPropagation()}>
                {payAlerts.map(a=>(
                  <div key={a._id} style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12,fontSize:12,fontFamily:"'DM Sans',sans-serif"}}>
                    <div style={{minWidth:0}}>
                      <div style={{color:"#f87171",fontWeight:700,fontSize:10,letterSpacing:"0.06em"}}>{a.type.replace(/_/g," ")}{a.count>1?` · seen ${a.count}×`:""}</div>
                      <div style={{color:"#e8d5a3",lineHeight:1.5}}>{a.message}</div>
                      <div style={{color:"#7a5a30",fontSize:10,marginTop:2}}>{fmtDate(a.firstSeenAt)}{a.paymentId?` · ${a.paymentId}`:""}</div>
                    </div>
                    <button onClick={()=>resolvePayAlert(a._id)} style={{flexShrink:0,padding:"5px 10px",background:"transparent",border:"1px solid rgba(200,160,74,0.3)",borderRadius:6,color:"#c8a04a",fontSize:11,cursor:"pointer"}}>✓ Resolved</button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {stockAlerts.length > 0 && (
          <div className="alert-banner" style={{
            background:"rgba(245,158,11,0.08)", border:"1px solid rgba(245,158,11,0.3)",
            borderRadius:12, padding:"14px 18px", marginBottom:20, cursor:"pointer",
            transition:"border-color .2s",
          }} onClick={()=>setAlertsOpen(v=>!v)}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:12}}>
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                <span style={{fontSize:18}}>⚠️</span>
                <span style={{fontSize:13,fontWeight:700,color:"#f5c842",fontFamily:"'DM Sans',sans-serif"}}>
                  {stockAlerts.length} product{stockAlerts.length!==1?"s":""} running low or sold out
                </span>
              </div>
              <span style={{fontSize:11,color:"#7a5a30",fontFamily:"'DM Sans',sans-serif"}}>
                {alertsOpen ? "Hide ▲" : "View ▼"}
              </span>
            </div>
            {alertsOpen && (
              <div style={{marginTop:12,paddingTop:12,borderTop:"1px solid rgba(245,158,11,0.2)",display:"flex",flexDirection:"column",gap:8}}
                onClick={e=>e.stopPropagation()}>
                {stockAlerts.map((a,i)=>(
                  <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:12,fontFamily:"'DM Sans',sans-serif"}}>
                    <span style={{color:"#e8d5a3"}}>
                      {a.productName}{a.color&&a.color!=="—"?` — ${a.color}`:""}
                    </span>
                    <span style={{
                      fontWeight:700,
                      color: a.soldOut ? "#f87171" : "#f5c842",
                      background: a.soldOut ? "rgba(198,40,40,0.12)" : "rgba(245,158,11,0.12)",
                      padding:"2px 8px", borderRadius:4,
                    }}>
                      {a.soldOut ? "SOLD OUT" : `${a.stock} left`}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* STAT CARDS */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:16,marginBottom:28}}>
          {[
            {label:"Total Products",val:products.length,icon:"🛍️",sub:"In catalogue"},
            {label:"Total Orders",val:orders.length,icon:"📦",sub:"All time"},
            {label:"Revenue",val:`₹${revenue.toLocaleString()}`,icon:"💰",sub:"Total earned"},
            {label:"Low / Sold Out",val:stockAlerts.length,icon:"🚫",sub:"Need restock"},
          ].map((s,i)=>(
            <div key={i} className="stat-card" style={S.statCard}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                <div>
                  <div style={{fontSize:11,color:"#7a5a30",fontFamily:"'DM Sans',sans-serif",letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:8}}>{s.label}</div>
                  <div style={{fontFamily:"'Playfair Display',serif",fontSize:28,color:"#e8d5a3",fontWeight:600,lineHeight:1}}>{s.val}</div>
                  <div style={{fontSize:11,color:"#5a3a10",marginTop:6,fontFamily:"'DM Sans',sans-serif"}}>{s.sub}</div>
                </div>
                <span style={{fontSize:24,opacity:0.6}}>{s.icon}</span>
              </div>
            </div>
          ))}
        </div>

        {/* ══ CATEGORIES TAB ══ */}
        {tab==="categories"&&(
          <CategoryManager
            API={API}
            pass={pass}
            categories={categories}
            onChanged={onCategoriesChanged}
          />
        )}

        {/* ══ PRODUCTS TAB ══ */}
        {tab==="products"&&(
          <div style={S.panel}>

            {/* ADMIN CATEGORY PREVIEW — built from the database; clicking a
                 tile pre-filters the search/filter row below to that category */}
            <div style={{ marginBottom:20 }}>
              <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:10, cursor:"pointer" }}
                onClick={()=>setCategoryPreviewOpen(v=>!v)}>
                <span style={{ fontSize:13, fontWeight:700, color:"#c8a04a", fontFamily:"'DM Sans',sans-serif", letterSpacing:"0.05em", textTransform:"uppercase" }}>
                  Categories
                </span>
                <span style={{ fontSize:11, color:"#7a5a30", fontFamily:"'DM Sans',sans-serif" }}>
                  {categoryPreviewOpen ? "Hide ▲" : "Show ▼"}
                </span>
              </div>
              {categoryPreviewOpen && (
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(150px,1fr))", gap:10 }}>
                  {categories.map((c)=>(
                    <div key={c._id} className="cat-card"
                      onClick={()=>{ updateCategory(categoryFilter===c._id?"All":c._id); }}
                      style={{
                        background: categoryFilter===c._id ? "rgba(200,160,74,0.15)" : "#1a1008",
                        border: categoryFilter===c._id ? "1px solid rgba(200,160,74,0.5)" : "1px solid rgba(200,160,74,0.12)",
                        borderRadius:10, padding:"14px 12px", cursor:"pointer",
                        transition:"all .15s", opacity:c.isActive?1:0.6,
                      }}>
                      <div style={{ fontSize:13, fontWeight:600, color:"#e8d5a3", fontFamily:"'DM Sans',sans-serif", marginBottom:4 }}>
                        {c.name}
                      </div>
                      <div style={{ fontSize:11, color: c.productCount===0 ? "#5a3a10" : "#c8a04a", fontFamily:"'DM Sans',sans-serif" }}>
                        {c.productCount} Product{c.productCount!==1?"s":""}{!c.isActive?" · inactive":""}
                      </div>
                    </div>
                  ))}
                  {categories.length===0 && (
                    <div style={{ gridColumn:"1/-1", fontSize:12, color:"#5a3a10" }}>
                      No categories yet — add some in the Categories tab.
                    </div>
                  )}
                </div>
              )}
            </div>

            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
              <div style={{fontFamily:"'DM Sans',sans-serif",fontSize:13,color:"#9a7050"}}>
                {filteredProducts.length} of {products.length} products
                {soldOutCount>0&&<span style={{color:"#f87171"}}> · {soldOutCount} sold out</span>}
              </div>
              <button onClick={()=>{ if(!showAddForm && categoryFilter!=="All") setAddForm(f=>({...f,categoryId:categoryFilter})); setShowAddForm(!showAddForm);setAddImages([]);setAddSizeStock({});}}
                style={{background:showAddForm?"rgba(198,40,40,0.15)":"#c8a04a",color:showAddForm?"#f87171":"#1a1008",border:showAddForm?"1px solid rgba(198,40,40,0.3)":"none",padding:"9px 20px",fontSize:12,fontWeight:600,borderRadius:8,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",letterSpacing:"0.06em",transition:"all .2s"}}>
                {showAddForm?"✕ Cancel":"+ Add Product"}
              </button>
            </div>

            <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:20}}>
              <input
                value={productSearch}
                onChange={e=>updateSearch(e.target.value)}
                placeholder="🔍 Search by name, category, fabric, color…"
                style={{...S.formInput,flex:"1 1 240px",padding:"10px 14px",fontSize:13}}
              />
              <select value={categoryFilter} onChange={e=>updateCategory(e.target.value)}
                style={{...S.formInput,width:200,padding:"10px 12px",fontSize:13}}>
                <option value="All">All Categories</option>
                {categories.map(c=><option key={c._id} value={c._id}>{c.name}</option>)}
              </select>
              <select value={stockFilter} onChange={e=>updateStock(e.target.value)}
                style={{...S.formInput,width:150,padding:"10px 12px",fontSize:13}}>
                {["All","In Stock","Low Stock","Sold Out"].map(s=><option key={s} value={s}>{s}</option>)}
              </select>
              {(productSearch||categoryFilter!=="All"||stockFilter!=="All") && (
                <button onClick={()=>{updateSearch("");updateCategory("All");updateStock("All");}}
                  style={{padding:"10px 16px",background:"transparent",border:"1px solid rgba(200,160,74,0.25)",borderRadius:8,color:"#9a7050",fontSize:12,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>
                  Clear filters
                </button>
              )}
            </div>

            {addSuccess&&<div style={{background:"rgba(74,222,128,0.1)",border:"1px solid rgba(74,222,128,0.3)",color:"#4ade80",padding:"10px 16px",borderRadius:8,marginBottom:16,fontSize:13}}>✅ {addSuccess}</div>}

            {showAddForm&&(
              <div style={S.addForm}>
                <h3 style={{fontFamily:"'Playfair Display',serif",fontSize:17,color:"#e8d5a3",marginBottom:20}}>New Product</h3>
                <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14}}>
                  <div style={{gridColumn:"1/-1"}}><label style={S.formLabel}>Product Name *</label><input value={addForm.name} onChange={e=>setAddForm({...addForm,name:e.target.value})} placeholder="e.g. Kalamkari Blouse" style={S.formInput}/></div>
                  {[["price","Selling Price (₹) *","number"],["originalPrice","Original Price (₹)","number"]].map(([k,l,t])=>(
                    <div key={k}><label style={S.formLabel}>{l}</label><input type={t} value={addForm[k]} onChange={e=>setAddForm({...addForm,[k]:e.target.value})} style={S.formInput}/></div>
                  ))}
                  <div>
                    <label style={S.formLabel}>Fabric</label>
                    <select value={addForm.fabric} onChange={e=>setAddForm({...addForm,fabric:e.target.value})} style={S.formInput}>
                      <option value="">Select</option>
                      {["Silk","Cotton","Chiffon","Georgette","Organza","Linen","Banarasi","Chanderi"].map(f=><option key={f}>{f}</option>)}
                    </select>
                  </div>
                  <div><label style={S.formLabel}>Color</label><input value={addForm.color} onChange={e=>setAddForm({...addForm,color:e.target.value})} placeholder="Blue, ALL COLOURS" style={S.formInput}/></div>
                  <div>
                    <label style={S.formLabel}>Category *</label>
                    <select value={addForm.categoryId} onChange={e=>setAddForm({...addForm,categoryId:e.target.value})} style={S.formInput}>
                      <option value="">Select Category</option>
                      {activeCategories.map(c=><option key={c._id} value={c._id}>{c.name}</option>)}
                    </select>
                  </div>

                  <div style={{gridColumn:"1/-1"}}>
                    <label style={S.formLabel}>Sizes (comma separated)</label>
                    <input value={addForm.sizes} onChange={e=>{
                      setAddForm({...addForm,sizes:e.target.value});
                      const newSizes=e.target.value.split(",").map(s=>s.trim()).filter(Boolean);
                      const newSS={...addSizeStock};
                      newSizes.forEach(s=>{ if(newSS[s]===undefined) newSS[s]=0; });
                      setAddSizeStock(newSS);
                    }} placeholder="XS,S,M,L,XL,XXL" style={S.formInput}/>
                  </div>

                  {addFormSizes.length > 0 && (
                    <div style={{gridColumn:"1/-1"}}>
                      <SizeStockEditor
                        sizes={addFormSizes}
                        sizeStock={addSizeStock}
                        onChange={(size, val) => setAddSizeStock({...addSizeStock, [size]: Number(val)||0})}
                      />
                    </div>
                  )}

                  {addFormSizes.length === 0 && (
                    <div>
                      <label style={S.formLabel}>Total Stock Quantity</label>
                      <input type="number" value={addForm.stock} onChange={e=>setAddForm({...addForm,stock:e.target.value})} style={S.formInput}/>
                    </div>
                  )}

                  <div style={{gridColumn:"1/-1"}}><label style={S.formLabel}>Description</label><textarea value={addForm.description} rows={3} onChange={e=>setAddForm({...addForm,description:e.target.value})} placeholder="Describe the product..." style={{...S.formInput,resize:"vertical",height:80}}/></div>

                  <div style={{gridColumn:"1/-1"}}>
                    <label style={S.formLabel}>Product Images * ({addImages.length}/4)</label>
                    <label className="upload-zone" style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"28px",border:"2px dashed rgba(200,160,74,0.35)",borderRadius:8,cursor:"pointer",background:"rgba(200,160,74,0.03)",transition:"all .2s"}}>
                      <span style={{fontSize:32,marginBottom:8}}>📷</span>
                      <span style={{fontSize:13,color:"#c8a04a",fontFamily:"'DM Sans',sans-serif",fontWeight:600}}>Click to upload images</span>
                      <span style={{fontSize:11,color:"#7a5a30",marginTop:4}}>PNG, JPG · Hold Ctrl for multiple</span>
                      <input type="file" multiple accept="image/*" onChange={handleImageSelect} style={{display:"none"}}/>
                    </label>
                    {addImages.length>0&&(
                      <div style={{display:"flex",gap:10,flexWrap:"wrap",marginTop:14}}>
                        {addImages.map((img,i)=>(
                          <div key={i} style={{position:"relative"}}>
                            {i===0&&<div style={{position:"absolute",bottom:0,left:0,right:0,background:"rgba(200,160,74,0.92)",color:"#1a1008",fontSize:9,fontWeight:700,textAlign:"center",padding:"3px 0",borderRadius:"0 0 6px 6px"}}>MAIN</div>}
                            <img src={URL.createObjectURL(img)} alt="" style={{width:88,height:88,objectFit:"cover",borderRadius:6,border:i===0?"2px solid #c8a04a":"1px solid rgba(200,160,74,0.25)",display:"block"}}/>
                            <div onClick={()=>setAddImages(addImages.filter((_,j)=>j!==i))} style={{position:"absolute",top:-7,right:-7,width:20,height:20,borderRadius:"50%",background:"#c62828",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,cursor:"pointer",fontWeight:700}}>✕</div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div style={{display:"flex",gap:10,marginTop:20}}>
                  <button onClick={handleAddProduct} disabled={addLoading} style={{background:addLoading?"#5a3a10":"#c8a04a",color:"#1a1008",border:"none",padding:"10px 24px",fontSize:13,fontWeight:600,borderRadius:8,cursor:addLoading?"not-allowed":"pointer",transition:"all .2s"}}>{addLoading?"Uploading...":"Save Product"}</button>
                  <button onClick={()=>{setShowAddForm(false);setAddImages([]);setAddSizeStock({});}} style={{background:"transparent",color:"#9a7050",border:"1px solid rgba(200,160,74,0.2)",padding:"10px 20px",fontSize:13,borderRadius:8,cursor:"pointer"}}>Cancel</button>
                </div>
              </div>
            )}

            {/* PRODUCT GRID */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:16}}>
              {products.length===0?(
                <div style={{gridColumn:"1/-1",textAlign:"center",padding:"60px 0",color:"#5a3a10",fontFamily:"'DM Sans',sans-serif",fontSize:14}}>No products yet.</div>
              ):filteredProducts.length===0?(
                <div style={{gridColumn:"1/-1",textAlign:"center",padding:"60px 0",color:"#5a3a10",fontFamily:"'DM Sans',sans-serif",fontSize:14}}>
                  No products match your search/filters.
                </div>
              ):pagedProducts.map((p)=>{
                const imgUrl=getImgUrl(p.images?.[0]);
                const soldOut=isSoldOut(p);
                const sizeStock=getSizeStock(p);
                const hasSizes=p.sizes?.length>0;
                const isEstimatedStock = hasSizes && !(p.sizeStock && Object.keys(p.sizeStock).length>0);
                const productCategoryName = catName(p);
                return(
                  <div key={p._id} style={S.productCard}>
                    <div style={{position:"relative",height:200,background:"#1a1008",borderRadius:"8px 8px 0 0",overflow:"hidden"}}>
                      {imgUrl?<img src={imgUrl} alt={p.name} onError={e=>{e.target.style.display="none";}} style={{width:"100%",height:"100%",objectFit:"cover"}}/>:<div style={{width:"100%",height:"100%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:48,opacity:0.3}}>🥻</div>}
                      {p.images?.length>1&&<div style={{position:"absolute",bottom:8,left:8,background:"rgba(0,0,0,0.7)",color:"#c8a04a",fontSize:10,fontWeight:600,padding:"2px 7px",borderRadius:4}}>📷 {p.images.length}</div>}
                      <div style={{position:"absolute",top:10,left:10,background:soldOut?"rgba(198,40,40,0.9)":"rgba(74,222,128,0.9)",color:"#fff",fontSize:10,fontWeight:700,padding:"3px 8px",borderRadius:4}}>{soldOut?"SOLD OUT":"IN STOCK"}</div>
                      <div style={{position:"absolute",top:10,right:10,background:"rgba(0,0,0,0.7)",color:Number(p.stock)<=3?"#f87171":"#c8a04a",fontSize:11,fontWeight:600,padding:"3px 8px",borderRadius:4}}>{Number(p.stock)||0} total</div>
                    </div>
                    <div style={{padding:"14px 16px"}}>
                      <h4 style={{fontFamily:"'Playfair Display',serif",fontSize:14,color:"#e8d5a3",margin:"0 0 4px",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{p.name}</h4>
                      <p style={{fontSize:11,color:"#7a5a30",margin:"0 0 8px",fontFamily:"'DM Sans',sans-serif"}}>
                        {productCategoryName && (
                          <span style={{ background:"rgba(200,160,74,0.15)", color:"#c8a04a", padding:"2px 7px", borderRadius:4, fontWeight:600, marginRight:6 }}>
                            {productCategoryName}
                          </span>
                        )}
                        {p.fabric?` ${p.fabric}`:""}{p.color?` · ${p.color}`:""}
                      </p>

                      {hasSizes && (
                        <div style={{marginBottom:10}}>
                          <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
                            <div style={{fontSize:9,color:"#5a3a10",fontWeight:700,textTransform:"uppercase",letterSpacing:"0.08em"}}>Stock by Size</div>
                            {isEstimatedStock && (
                              <span title="These numbers are an even-split estimate, not real saved per-size stock. Open Edit and Save once to make them real and enforced."
                                style={{fontSize:8,fontWeight:700,color:"#f5c842",background:"rgba(245,158,11,0.12)",border:"1px solid rgba(245,158,11,0.3)",borderRadius:4,padding:"1px 6px",cursor:"help"}}>
                                ⚠️ ESTIMATE — not enforced yet
                              </span>
                            )}
                          </div>
                          <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                            {p.sizes.map(size=>{
                              const qty=Number(sizeStock[size]||0);
                              return(
                                <div key={size} style={{
                                  background:qty===0?"rgba(198,40,40,0.15)":"rgba(200,160,74,0.1)",
                                  border:`1px solid ${qty===0?"rgba(198,40,40,0.4)":"rgba(200,160,74,0.25)"}`,
                                  borderRadius:5,padding:"3px 7px",textAlign:"center",
                                }}>
                                  <div style={{fontSize:9,fontWeight:700,color:qty===0?"#f87171":"#c8a04a",fontFamily:"'DM Sans',sans-serif"}}>{size}</div>
                                  <div style={{fontSize:11,fontWeight:700,color:qty===0?"#f87171":"#e8d5a3",fontFamily:"monospace"}}>{qty===0?"✕":qty}</div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      <div style={{display:"flex",alignItems:"baseline",gap:8,marginBottom:12}}>
                        <span style={{fontFamily:"'Playfair Display',serif",fontSize:18,color:"#c8a04a",fontWeight:600}}>₹{Number(p.price).toLocaleString()}</span>
                        {p.originalPrice>p.price&&<span style={{fontSize:12,color:"#5a3a10",textDecoration:"line-through"}}>₹{Number(p.originalPrice).toLocaleString()}</span>}
                      </div>
                      <div style={{display:"flex",gap:8}}>
                        <button className="action-btn" onClick={()=>{
                          setEditingProduct(editingProduct===p._id?null:p._id);
                          setEditForm({name:p.name,description:p.description||"",price:p.price,originalPrice:p.originalPrice||"",stock:p.stock,fabric:p.fabric||"",color:p.color||"",categoryId:pCatId(p),sizes:p.sizes?.join(",")|| ""});
                          setEditSizeStock(getSizeStock(p));
                        }} style={{flex:1,padding:"7px 0",background:"rgba(200,160,74,0.15)",color:"#c8a04a",border:"1px solid rgba(200,160,74,0.25)",borderRadius:6,fontSize:11,fontWeight:600,cursor:"pointer",transition:"all .15s"}}>✏️ Edit</button>
                        <button className="action-btn" onClick={()=>handleDeleteProduct(p._id)} style={{flex:1,padding:"7px 0",background:"rgba(198,40,40,0.1)",color:"#f87171",border:"1px solid rgba(198,40,40,0.2)",borderRadius:6,fontSize:11,fontWeight:600,cursor:"pointer",transition:"all .15s"}}>🗑 Delete</button>
                      </div>
                    </div>

                    {/* EDIT PANEL */}
                    {editingProduct===p._id&&(
                      <div style={{borderTop:"1px solid rgba(200,160,74,0.15)",padding:"16px",background:"rgba(200,160,74,0.03)"}}>
                        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                          {[["name","Name"],["price","Price (₹)"],["originalPrice","Orig. Price"],["fabric","Fabric"],["color","Color"]].map(([k,l])=>(
                            <div key={k}><label style={S.formLabel}>{l}</label><input value={editForm[k]||""} type={["price","originalPrice"].includes(k)?"number":"text"} onChange={e=>setEditForm({...editForm,[k]:e.target.value})} style={{...S.formInput,padding:"6px 10px",fontSize:12}}/></div>
                          ))}

                          <div>
                            <label style={S.formLabel}>Category</label>
                            <select value={editForm.categoryId||""} onChange={e=>setEditForm({...editForm,categoryId:e.target.value})} style={{...S.formInput,padding:"6px 10px",fontSize:12}}>
                              <option value="">Select Category</option>
                              {optionsFor(editForm.categoryId).map(c=><option key={c._id} value={c._id}>{c.name}{!c.isActive?" (inactive)":""}</option>)}
                            </select>
                          </div>

                          <div style={{gridColumn:"1/-1"}}>
                            <label style={S.formLabel}>Sizes (comma separated)</label>
                            <input value={editForm.sizes||""} onChange={e=>{
                              setEditForm({...editForm,sizes:e.target.value});
                              const newSizes=e.target.value.split(",").map(s=>s.trim()).filter(Boolean);
                              const newSS={...editSizeStock};
                              newSizes.forEach(s=>{ if(newSS[s]===undefined) newSS[s]=0; });
                              setEditSizeStock(newSS);
                            }} style={{...S.formInput,padding:"6px 10px",fontSize:12}}/>
                          </div>

                          {(() => {
                            const editSizes=(editForm.sizes||"").split(",").map(s=>s.trim()).filter(Boolean);
                            return editSizes.length > 0 ? (
                              <div style={{gridColumn:"1/-1"}}>
                                <SizeStockEditor
                                  sizes={editSizes}
                                  sizeStock={editSizeStock}
                                  onChange={(size,val)=>setEditSizeStock({...editSizeStock,[size]:Number(val)||0})}
                                />
                              </div>
                            ) : (
                              <div>
                                <label style={S.formLabel}>Stock</label>
                                <input value={editForm.stock||""} type="number" onChange={e=>setEditForm({...editForm,stock:e.target.value})} style={{...S.formInput,padding:"6px 10px",fontSize:12}}/>
                              </div>
                            );
                          })()}

                          <div style={{gridColumn:"1/-1"}}><label style={S.formLabel}>Description</label><textarea value={editForm.description||""} rows={2} onChange={e=>setEditForm({...editForm,description:e.target.value})} style={{...S.formInput,resize:"vertical",height:60,fontSize:12}}/></div>

                          <div style={{gridColumn:"1/-1"}}>
                            <label style={S.formLabel}>Quick Actions</label>
                            <div style={{display:"flex",gap:8}}>
                              <button onClick={()=>markSoldOut(p)} style={{flex:1,padding:"8px",background:"rgba(198,40,40,0.15)",color:"#f87171",border:"1px solid rgba(198,40,40,0.3)",borderRadius:6,fontSize:11,fontWeight:600,cursor:"pointer"}}>🚫 All Sizes → 0</button>
                              <button onClick={()=>markInStock(p,10)} style={{flex:1,padding:"8px",background:"rgba(74,222,128,0.1)",color:"#4ade80",border:"1px solid rgba(74,222,128,0.2)",borderRadius:6,fontSize:11,fontWeight:600,cursor:"pointer"}}>✅ Restock All (10)</button>
                            </div>
                          </div>
                        </div>
                        <div style={{display:"flex",gap:8,marginTop:12}}>
                          <button onClick={()=>handleUpdateProduct(p._id)} style={{flex:1,padding:"8px",background:"#c8a04a",color:"#1a1008",border:"none",borderRadius:6,fontSize:12,fontWeight:600,cursor:"pointer"}}>Save Changes</button>
                          <button onClick={()=>setEditingProduct(null)} style={{flex:1,padding:"8px",background:"transparent",color:"#9a7050",border:"1px solid rgba(200,160,74,0.2)",borderRadius:6,fontSize:12,cursor:"pointer"}}>Cancel</button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            {filteredProducts.length > PAGE_SIZE && (
              <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:10,marginTop:26}}>
                <button className="page-btn" disabled={safePage<=1}
                  onClick={()=>setCurrentPage(p=>Math.max(1,p-1))}
                  style={{padding:"8px 16px",background:"transparent",border:"1px solid rgba(200,160,74,0.25)",borderRadius:8,color:"#9a7050",fontSize:12,fontFamily:"'DM Sans',sans-serif",cursor:"pointer",transition:"all .15s"}}>
                  ← Prev
                </button>
                <span style={{fontSize:12,color:"#7a5a30",fontFamily:"'DM Sans',sans-serif"}}>
                  Page {safePage} of {totalPages}
                </span>
                <button className="page-btn" disabled={safePage>=totalPages}
                  onClick={()=>setCurrentPage(p=>Math.min(totalPages,p+1))}
                  style={{padding:"8px 16px",background:"transparent",border:"1px solid rgba(200,160,74,0.25)",borderRadius:8,color:"#9a7050",fontSize:12,fontFamily:"'DM Sans',sans-serif",cursor:"pointer",transition:"all .15s"}}>
                  Next →
                </button>
              </div>
            )}
          </div>
        )}

        {/* ══ ORDERS TAB ══ */}
        {tab==="orders"&&(
          <div style={S.panel}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:10}}>
              <span style={{fontFamily:"'DM Sans',sans-serif",fontSize:13,color:"#9a7050"}}>
                {visibleOrders.length} {ordersFiltered?"matching":"total"} order{visibleOrders.length!==1?"s":""}{ordersFiltered?` of ${orders.length}`:""}
              </span>
              <button type="button" disabled={!visibleOrders.length} onClick={()=>downloadOrdersExcel(visibleOrders)}
                title={ordersFiltered?"Download only the orders matching your filters":"Download all orders"}
                style={{fontFamily:"'DM Sans',sans-serif",fontSize:12,fontWeight:600,padding:"6px 14px",borderRadius:8,cursor:visibleOrders.length?"pointer":"not-allowed",opacity:visibleOrders.length?1:0.5,background:"rgba(34,160,90,0.15)",border:"1px solid rgba(34,160,90,0.5)",color:"#4ade80"}}>
                ⬇ Download Excel ({visibleOrders.length})
              </button>
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                {["All","Pending","Confirmed","Shipped","Delivered","Cancelled"].map(f=>(
                  <span key={f} className="fpill" onClick={()=>{setFilter(f);setOrderDraft(d=>({...d,status:f}));}}
                    style={{fontSize:11,padding:"4px 12px",borderRadius:12,background:filter===f?"rgba(200,160,74,0.25)":"rgba(200,160,74,0.07)",border:filter===f?"1px solid rgba(200,160,74,0.6)":"1px solid rgba(200,160,74,0.15)",color:filter===f?"#c8a04a":"#7a5a30",fontWeight:filter===f?600:400}}>
                    {f}
                  </span>
                ))}
              </div>
            </div>
            <OrderFilterPanel open={showOrderFilters} setOpen={setShowOrderFilters}
              draft={orderDraft} setDraft={setOrderDraft} onApply={applyOrderFilterDraft} onClear={clearOrderFilters}
              onRange={quickOrderRange} appliedRange={orderApplied.range}
              methods={orderMethods} matching={visibleOrders.length} total={orders.length} active={ordersFiltered}/>
            <div style={{display:"flex",flexDirection:"column",gap:14}}>
              {visibleOrders.length===0?(
                <div style={{textAlign:"center",padding:"60px 0",color:"#5a3a10",fontFamily:"'DM Sans',sans-serif"}}>{orders.length&&ordersFiltered?"No orders match these filters.":"No orders yet."}</div>
              ):visibleOrders.map((o)=>{
                const sc=STATUS_CFG[o.status]||STATUS_CFG.Pending;
                const itemList=Array.isArray(o.products)&&o.products.length>0?o.products:Array.isArray(o.items)&&o.items.length>0?o.items:[];
                const totalAmt=Number(o.total_amount||o.totalAmount||0);
                const payMethod=o.payment_method||o.paymentMethod||"—";
                const addrData=renderAddress(o.address,o.userName||o.email?.split("@")[0]);
                return(
                  <div key={o._id} style={{...S.orderCard,padding:0,overflow:"hidden"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12,padding:"14px 20px",borderBottom:"1px solid rgba(200,160,74,0.1)",background:"rgba(200,160,74,0.03)"}}>
                      <div style={{display:"flex",alignItems:"center",gap:12}}>
                        <div style={{width:38,height:38,borderRadius:"50%",background:"linear-gradient(135deg,#c8a04a,#8b5e1a)",display:"flex",alignItems:"center",justifyContent:"center",color:"#1a1008",fontSize:15,fontWeight:700,fontFamily:"'Playfair Display',serif",flexShrink:0}}>{(o.email||"G")[0].toUpperCase()}</div>
                        <div>
                          <div style={{display:"flex",alignItems:"center",gap:8}}>
                            <span style={{fontFamily:"'Playfair Display',serif",fontSize:14,color:"#e8d5a3",fontWeight:600}}>{o.email?.split("@")[0]||"Guest"}</span>
                            <span style={{fontSize:10,color:"#5a3a10",fontFamily:"monospace",background:"rgba(200,160,74,0.1)",padding:"2px 7px",borderRadius:4}}>#{String(o._id).slice(-6).toUpperCase()}</span>
                            {newOrderIds.includes(o._id)&&<span style={{fontSize:10,fontWeight:700,color:"#fff",background:"#dc2626",padding:"2px 8px",borderRadius:999,letterSpacing:"0.06em"}}>NEW</span>}
                            {o.recoveredAt&&<span title={`Rebuilt from the saved cart on ${fmtDate(o.recoveredAt)}`} style={{fontSize:10,fontWeight:700,color:"#4da6ff",background:"rgba(77,166,255,0.12)",border:"1px solid rgba(77,166,255,0.35)",padding:"2px 8px",borderRadius:999}}>RECOVERED</span>}
                            {o.needsReview&&<span style={{fontSize:10,fontWeight:700,color:"#f5c842",background:"rgba(245,158,11,0.12)",border:"1px solid rgba(245,158,11,0.35)",padding:"2px 8px",borderRadius:999}}>⚠️ CHECK</span>}
                          </div>
                          {o.needsReview&&<div style={{fontSize:11,color:"#f5c842",fontFamily:"'DM Sans',sans-serif",marginTop:3}}>⚠️ {o.needsReview}</div>}
                          <div style={{fontSize:11,color:"#7a5a30",fontFamily:"'DM Sans',sans-serif",marginTop:2}}>{o.email} · 🕒 {fmtDateTime(o.createdAt||o.created_at)}</div>
                        </div>
                      </div>
                      <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
                        <button className="wa-btn" onClick={()=>sendOrderToWhatsApp(o)}
                          style={{display:"flex",alignItems:"center",gap:6,padding:"6px 12px",background:"linear-gradient(135deg,#25d366,#128c7e)",color:"#fff",border:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer",boxShadow:"0 2px 8px rgba(37,211,102,.25)",transition:"opacity .2s,transform .2s"}}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                          WhatsApp
                        </button>
                        <InvoiceGenerator order={o}/>
                        <div style={{textAlign:"right"}}>
                          <div style={{fontFamily:"'Playfair Display',serif",fontSize:20,color:"#c8a04a",fontWeight:600}}>₹{totalAmt.toLocaleString()}</div>
                          <div style={{fontSize:10,color:"#7a5a30",fontFamily:"'DM Sans',sans-serif"}}>{payMethod}</div>
                        </div>
                        <div style={{padding:"4px 12px",borderRadius:20,fontSize:11,fontWeight:700,background:sc.bg,color:sc.color,display:"flex",alignItems:"center",gap:5}}>
                          <span style={{width:6,height:6,borderRadius:"50%",background:sc.dot}}/>{o.status||"Confirmed"}
                        </div>
                        <select value={o.status||"Confirmed"} onChange={e=>handleOrderStatus(o._id,e.target.value)}
                          style={{padding:"5px 10px",fontSize:11,background:"#2a1a08",border:"1px solid rgba(200,160,74,0.25)",borderRadius:6,color:"#c8a04a",cursor:"pointer",outline:"none"}}>
                          {["Pending","Confirmed","Shipped","Delivered","Cancelled"].map(s=><option key={s}>{s}</option>)}
                        </select>
                      </div>
                    </div>

                    <div style={{display:"grid",gridTemplateColumns:"1fr 220px",padding:"18px 20px",gap:0}}>
                      <div style={{paddingRight:16}}>
                        <div style={{fontSize:10,color:"#5a3a10",fontWeight:700,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:10}}>Items Ordered ({itemList.length})</div>
                        {itemList.length===0?(<div style={{fontSize:12,color:"#5a3a10",fontStyle:"italic"}}>No item details</div>):(
                          <div style={{display:"flex",flexDirection:"column",gap:10}}>
                            {itemList.map((item,j)=>{
                              const imgUrl=getItemImg(item);
                              return(
                                <div key={j} style={{display:"flex",alignItems:"center",gap:12,background:"rgba(200,160,74,0.04)",padding:"10px 12px",borderRadius:8,border:"1px solid rgba(200,160,74,0.1)"}}>
                                  {imgUrl?(<img src={imgUrl} alt={item.name} onError={e=>{e.target.onerror=null;e.target.src="/images/s1.png";}} style={{width:64,height:72,objectFit:"cover",borderRadius:4,flexShrink:0,border:"1px solid rgba(200,160,74,0.2)"}}/>):(<div style={{width:64,height:72,borderRadius:4,background:"rgba(200,160,74,0.08)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:26,flexShrink:0}}>🥻</div>)}
                                  <div style={{flex:1,minWidth:0}}>
                                    <div style={{fontSize:13,color:"#e8d5a3",fontWeight:600,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{item.name}</div>
                                    <div style={{fontSize:11,color:"#7a5a30",marginTop:3,display:"flex",gap:8,flexWrap:"wrap"}}>
                                      {(item.selectedSize||item.size)&&<span>Size: <strong style={{color:"#c8a04a"}}>{item.selectedSize||item.size}</strong></span>}
                                      {item.color&&<span>· <strong style={{color:"#c8a04a"}}>{item.color}</strong></span>}
                                      <span>· Qty: <strong style={{color:"#c8a04a"}}>{item.quantity||1}</strong></span>
                                    </div>
                                  </div>
                                  <div style={{flexShrink:0,textAlign:"right"}}>
                                    <div style={{fontFamily:"'Playfair Display',serif",fontSize:15,color:"#c8a04a",fontWeight:600}}>₹{(Number(item.price||0)*(item.quantity||1)).toLocaleString()}</div>
                                    {item.quantity>1&&<div style={{fontSize:10,color:"#5a3a10"}}>₹{Number(item.price||0).toLocaleString()} × {item.quantity}</div>}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                      <div style={{borderLeft:"1px solid rgba(200,160,74,0.1)",paddingLeft:16}}>
                        <div style={{fontSize:10,color:"#5a3a10",fontWeight:700,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:10}}>Delivery Address</div>
                        {addrData?(
                          <div style={{fontSize:12,color:"#9a7050",lineHeight:1.85}}>
                            <div style={{color:"#e8d5a3",fontWeight:600,fontSize:13,marginBottom:3}}>{addrData.name}</div>
                            {addrData.phone&&<div style={{color:"#c8a04a",marginBottom:4}}>📞 {addrData.phone}</div>}
                            {addrData.line1&&<div>{addrData.line1}</div>}
                            {addrData.line2&&<div>{addrData.line2}</div>}
                            {addrData.line3&&<div style={{fontWeight:600,color:"#b8a080"}}>{addrData.line3}</div>}
                          </div>
                        ):(<div style={{fontSize:12,color:"#5a3a10",fontStyle:"italic"}}>No address saved</div>)}
                        <div style={{marginTop:14,paddingTop:12,borderTop:"1px solid rgba(200,160,74,0.1)"}}>
                          <div style={{fontSize:10,color:"#5a3a10",fontWeight:700,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:4}}>Order ID</div>
                          <div style={{fontSize:9,color:"#7a5a30",fontFamily:"monospace",wordBreak:"break-all",lineHeight:1.5}}>{o._id}</div>
                          {o.paymentId&&<><div style={{fontSize:10,color:"#5a3a10",fontWeight:700,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:4,marginTop:8}}>Payment ID</div><div style={{fontSize:9,color:"#7a5a30",fontFamily:"monospace",wordBreak:"break-all"}}>{o.paymentId}</div></>}
                        </div>
                      </div>
                    </div>

                    {/* TRACKING */}
                    <div style={{padding:"12px 20px",borderTop:"1px solid rgba(200,160,74,0.1)"}}>
                      {o.trackingNumber?(
                        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
                          <div style={{display:"flex",alignItems:"center",gap:8}}>
                            <span style={{fontSize:14}}>🚚</span>
                            <div>
                              <div style={{fontSize:12,color:"#c8a04a",fontWeight:600}}>{o.courierName||"DTDC"} · {o.trackingNumber}</div>
                              {o.estimatedDelivery&&<div style={{fontSize:11,color:"#7a5a30"}}>Expected: {o.estimatedDelivery}</div>}
                            </div>
                          </div>
                          <div style={{display:"flex",gap:6}}>
                            <a href={o.trackingUrl||`https://www.dtdc.in/trace.asp?txtnbr=${o.trackingNumber}`} target="_blank" rel="noreferrer" style={{fontSize:11,background:"rgba(200,160,74,0.15)",color:"#c8a04a",border:"1px solid rgba(200,160,74,0.3)",padding:"4px 10px",borderRadius:6,textDecoration:"none",fontWeight:600}}>Track →</a>
                            <button onClick={()=>setTrackingOpen(trackingOpen===o._id?null:o._id)} style={{fontSize:11,background:"transparent",color:"#7a5a30",border:"1px solid rgba(200,160,74,0.2)",padding:"4px 10px",borderRadius:6,cursor:"pointer"}}>Update</button>
                          </div>
                        </div>
                      ):(
                        <button onClick={()=>setTrackingOpen(trackingOpen===o._id?null:o._id)} style={{fontSize:12,background:"rgba(200,160,74,0.1)",color:"#c8a04a",border:"1px solid rgba(200,160,74,0.25)",padding:"6px 14px",borderRadius:6,cursor:"pointer",fontWeight:600}}>🚚 Add Tracking / Ship Order</button>
                      )}
                      {trackingOpen===o._id&&(
                        <div style={{marginTop:12,background:"rgba(200,160,74,0.05)",border:"1px solid rgba(200,160,74,0.2)",borderRadius:8,padding:"14px"}}>
                          <div style={{fontSize:12,color:"#c8a04a",fontWeight:700,marginBottom:10}}>🚚 Add Shipping Details</div>
                          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                            <div>
                              <label style={S.formLabel}>Courier</label>
                              <select value={trackingForm[o._id]?.courierName||"DTDC"} onChange={e=>setTrackingForm({...trackingForm,[o._id]:{...(trackingForm[o._id]||{}),courierName:e.target.value}})} style={{...S.formInput,padding:"7px 10px",fontSize:12}}>
                                {["DTDC","Delhivery","Bluedart","Ekart","India Post","Shadowfax","Xpressbees"].map(c=><option key={c}>{c}</option>)}
                              </select>
                            </div>
                            <div>
                              <label style={S.formLabel}>Tracking Number *</label>
                              <div style={{display:"flex",gap:6}}>
                                <input placeholder="e.g. Z12345678" value={trackingForm[o._id]?.trackingNumber||""} onChange={e=>setTrackingForm({...trackingForm,[o._id]:{...(trackingForm[o._id]||{}),trackingNumber:e.target.value}})} style={{...S.formInput,padding:"7px 10px",fontSize:12,flex:1}}/>
                                <button className="scan-btn" onClick={()=>setScannerOpen(o._id)} style={{padding:"7px 11px",background:"rgba(200,160,74,0.15)",border:"1px solid rgba(200,160,74,0.3)",borderRadius:6,cursor:"pointer",fontSize:16,flexShrink:0}}>📷</button>
                              </div>
                            </div>
                            <div style={{gridColumn:"1/-1"}}>
                              <label style={S.formLabel}>Expected Delivery Date</label>
                              <input type="date" value={trackingForm[o._id]?.estimatedDelivery||""} onChange={e=>setTrackingForm({...trackingForm,[o._id]:{...(trackingForm[o._id]||{}),estimatedDelivery:e.target.value}})} style={{...S.formInput,padding:"7px 10px",fontSize:12}}/>
                            </div>
                          </div>
                          <div style={{display:"flex",gap:8,marginTop:10}}>
                            <button onClick={()=>handleAddTracking(o._id)} style={{flex:1,padding:"8px",background:"#c8a04a",color:"#1a1008",border:"none",borderRadius:6,fontSize:12,fontWeight:600,cursor:"pointer"}}>✅ Mark as Shipped</button>
                            <button onClick={()=>setTrackingOpen(null)} style={{padding:"8px 14px",background:"transparent",color:"#7a5a30",border:"1px solid rgba(200,160,74,0.2)",borderRadius:6,fontSize:12,cursor:"pointer"}}>Cancel</button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            {/* ✅ checkouts without an order: failed / cancelled / pending / paid-not-reconciled */}
            <PaymentAttemptsSection api={API} pass={pass} filters={orderFilters} getImgUrl={getImgUrl} onMethods={setAttemptMethods}/>
          </div>
        )}

        {/* ══ USERS TAB ══ */}
        {tab==="users"&&(
          <div style={S.panel}>
            <div style={{marginBottom:20,fontSize:13,color:"#9a7050"}}>{users.length} registered users</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:14}}>
              {users.map((u)=>(
                <div key={u._id} style={S.userCard}>
                  <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:12}}>
                    {u.photo?<img src={u.photo} alt="" style={{width:44,height:44,borderRadius:"50%",objectFit:"cover",border:"2px solid rgba(200,160,74,0.3)"}}/>:<div style={{width:44,height:44,borderRadius:"50%",background:"linear-gradient(135deg,#c8a04a,#8b5e1a)",display:"flex",alignItems:"center",justifyContent:"center",color:"#1a1008",fontSize:18,fontWeight:700,fontFamily:"'Playfair Display',serif"}}>{u.name?.[0]?.toUpperCase()||"?"}</div>}
                    <div>
                      <div style={{fontFamily:"'Playfair Display',serif",fontSize:14,color:"#e8d5a3",fontWeight:600}}>{u.name||"—"}</div>
                      <div style={{fontSize:11,color:"#7a5a30"}}>{u.email}</div>
                    </div>
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderTop:"1px solid rgba(200,160,74,0.1)"}}>
                    {[{v:u.loginCount||0,l:"Logins"},{v:fmtDate(u.lastLogin),l:"Last seen"},{v:fmtDate(u.createdAt),l:"Joined"}].map((x,i)=>(
                      <div key={i} style={{textAlign:"center"}}>
                        <div style={{fontSize:i===0?18:11,color:"#c8a04a",fontWeight:i===0?600:400}}>{x.v}</div>
                        <div style={{fontSize:10,color:"#5a3a10"}}>{x.l}</div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </main>

      {scannerOpen&&(
        <BarcodeScanner
          onScan={(code)=>{ setTrackingForm({...trackingForm,[scannerOpen]:{...(trackingForm[scannerOpen]||{}),trackingNumber:code}}); setScannerOpen(null); setTrackingOpen(scannerOpen); }}
          onClose={()=>setScannerOpen(null)}
        />
      )}
    </div>
  );
}

const S={
  loginPage:{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#0f0a04",backgroundImage:"radial-gradient(ellipse at 20% 50%,rgba(139,94,26,0.15) 0%,transparent 50%)"},
  loginBox:{background:"#1a1008",border:"1px solid rgba(200,160,74,0.2)",borderRadius:16,padding:"40px 36px",width:360,boxShadow:"0 24px 80px rgba(0,0,0,0.6)"},
  page:{display:"flex",minHeight:"100vh",background:"#0f0a04",fontFamily:"'DM Sans',sans-serif"},
  sidebar:{width:220,background:"#140d04",borderRight:"1px solid rgba(200,160,74,0.1)",display:"flex",flexDirection:"column",flexShrink:0,position:"sticky",top:0,height:"100vh"},
  main:{flex:1,padding:"28px 32px",overflowY:"auto",background:"#0f0a04"},
  topbar:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24},
  statCard:{background:"#1a1008",border:"1px solid rgba(200,160,74,0.15)",borderRadius:12,padding:"20px"},
  panel:{background:"#140d04",border:"1px solid rgba(200,160,74,0.1)",borderRadius:12,padding:"24px"},
  productCard:{background:"#1a1008",border:"1px solid rgba(200,160,74,0.12)",borderRadius:10,overflow:"hidden",transition:"border-color .2s"},
  orderCard:{background:"#1a1008",border:"1px solid rgba(200,160,74,0.12)",borderRadius:10},
  userCard:{background:"#1a1008",border:"1px solid rgba(200,160,74,0.12)",borderRadius:10,padding:"16px"},
  addForm:{background:"#1a1008",border:"1px solid rgba(200,160,74,0.2)",borderRadius:10,padding:"24px",marginBottom:24},
  formLabel:{display:"block",fontSize:10,fontWeight:600,color:"#7a5a30",textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:5,fontFamily:"'DM Sans',sans-serif"},
  formInput:{width:"100%",padding:"9px 12px",fontSize:13,background:"#0f0a04",border:"1px solid rgba(200,160,74,0.2)",borderRadius:6,color:"#e8d5a3",outline:"none",fontFamily:"'DM Sans',sans-serif",transition:"border-color .2s"},
};